import { render } from "./CreateAppointmentDay.vue?vue&type=template&id=a53bff64&scoped=true"
import script from "./CreateAppointmentDay.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentDay.vue?vue&type=script&lang=js"

import "./CreateAppointmentDay.vue?vue&type=style&index=0&id=a53bff64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53bff64"]])

export default __exports__